import ar from "./ar";
import en from "./en";

/*
 * Blog articles are ~200 KB of prose per locale. They used to live in
 * locales/{ar,en}.js, which every page loads, so every visitor downloaded the
 * full text of every blog post. Importing this module keeps that payload on the
 * pages that actually render blogs.
 *
 * The blog UI labels (title, intro, similar, ...) are small and stay in the
 * shared dictionary under `t.blogs`.
 */
export const blogsListByLocale = { ar, en };

export function getBlogsList(locale) {
  return blogsListByLocale[locale] ?? blogsListByLocale.ar;
}
